import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import whatwedoimage4 from "../../assets/images/WhatwedoImage4.png";
import whatwedo4 from "../../assets/images/Whatwedo/whatwedo4.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhatwedoContent = () => {

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "0rem 0rem",
        display: "flex",
        justifyContent: { xs: "start", md: "flex-start" },
        alignItems: { xs: "center", md: "start" },
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", sm: "55%", md: "40%" },
        }}
      >
        <Box
          sx={{
            width: { xs: "auto", md: "30rem" },
          }}
        >
          <LazyLoadImage
            src={isMdUp ? whatwedoimage4 : whatwedo4}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "58%" },
          padding: "0 2rem 2rem 2rem",
        }}
      >
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "0rem",
                fontSize: "1rem",
                display: "flex",
                alignItems: "flex-start",
              }}
            ></Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  marginRight: "0.5rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                •
              </span>
              <span style={{ fontFamily: "Plus Jakarta Sans" }}>
                Utilizing cutting-edge{" "}
                <span
                  style={{
                    color: "rgba(243, 107, 43, 1)",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    fontFamily: "Plus Jakarta Sans",
                  }}
                >
                  visualization tools such as PowerBI
                </span>
                , we harness intelligent technology to transform complex data
                into visually compelling narratives. Our solutions empower
                businesses to communicate insights effectively and drive
                informed decision-making across all levels.
              </span>
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  marginRight: "0.5rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                •
              </span>
              <span style={{ fontFamily: "Plus Jakarta Sans" }}>
                Our{" "}
                <span
                  style={{
                    color: "rgba(243, 107, 43, 1)",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    fontFamily: "Plus Jakarta Sans",
                  }}
                >
                  multiple filter-driven dashboards{" "}
                </span>
                enhance user-friendliness, allowing stakeholders to customize
                views and drill down into specific metrics with ease. This
                interactive approach ensures that users can access the
                information they need, when they need it, maximizing efficiency
                and productivity.
              </span>
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  marginRight: "0.5rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              ></span>
              <span style={{ fontFamily: "Plus Jakarta Sans" }}>
                Our visualization capabilities extend beyond traditional
                reporting, enabling businesses to improve the depth and quality
                of{" "}
                <span
                  style={{
                    color: "rgba(243, 107, 43, 1)",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    fontFamily: "Plus Jakarta Sans",
                  }}
                >
                  analysis across functions
                </span>
                . By visualizing data in meaningful ways, we help businesses
                uncover hidden patterns, identify trends, and make data-driven
                decisions with confidence.
              </span>

              <span style={{ marginTop: "1.5rem", color: "#111111", fontWeight: "400", fontFamily: "Plus Jakarta Sans" }}>
                Partner with us to harness the full potential of visualization and
                dashboarding capabilities and transform your data into actionable
                insights that drive business success.
              </span>
            </Typography>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default WhatwedoContent;
